import { useState } from "react";

import { cn } from "@/lib/utils";

interface BlurredEmailProps {
  email: string;
  displayName?: string | null;
  className?: string;
  /** When false (default), renders the email as plain text. When true, blurs until revealed. */
  active?: boolean;
}

export function BlurredEmail({
  email,
  displayName,
  className,
  active = false,
}: BlurredEmailProps) {
  const [revealed, setRevealed] = useState(false);
  const label = displayName?.trim() || email.split("@")[0];

  if (!active) {
    return (
      <span className={cn("inline-flex items-center gap-1.5", className)}>
        <span className="font-medium">{label}</span>
        <span className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs text-muted-foreground select-all">
          {email}
        </span>
      </span>
    );
  }

  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <span className="font-medium">{label}</span>
      <button
        type="button"
        aria-label={revealed ? "Hide email address" : "Reveal email address"}
        aria-pressed={revealed}
        onClick={() => setRevealed((r) => !r)}
        className={cn(
          "rounded bg-muted px-1.5 py-0.5 font-mono text-xs text-muted-foreground transition-[filter,color] select-all",
          "focus:blur-none focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          revealed ? "blur-none text-foreground" : "blur-sm",
        )}
      >
        {email}
      </button>
    </span>
  );
}
